module.exports = __webpack_public_path__ + "img/145.4.259b57da.png";